import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

/**
 * Enables click-and-drag horizontal (and vertical) scrolling on any scrollable
 * container. Apply as <div dragScroll> on the element that has overflow-x set.
 */
@Directive({ selector: '[dragScroll]' })
export class DragScrollDirective {
  private isDragging = false;
  private startX = 0;
  private startY = 0;
  private scrollLeft = 0;
  private scrollTop = 0;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mousedown', ['$event'])
  onMouseDown(e: MouseEvent) {
    // Only trigger on left-click and not on interactive elements
    if (e.button !== 0) return;
    const target = e.target as HTMLElement;
    if (target.closest('button, a, input, select, textarea')) return;

    this.isDragging = true;
    this.startX = e.pageX - this.el.nativeElement.offsetLeft;
    this.startY = e.pageY - this.el.nativeElement.offsetTop;
    this.scrollLeft = this.el.nativeElement.scrollLeft;
    this.scrollTop = this.el.nativeElement.scrollTop;
    this.renderer.setStyle(this.el.nativeElement, 'cursor', 'grabbing');
    this.renderer.setStyle(this.el.nativeElement, 'user-select', 'none');
    e.preventDefault();
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    if (!this.isDragging) return;
    const x = e.pageX - this.el.nativeElement.offsetLeft;
    const y = e.pageY - this.el.nativeElement.offsetTop;
    const walkX = (x - this.startX) * 1.5;
    const walkY = (y - this.startY) * 1.5;
    this.el.nativeElement.scrollLeft = this.scrollLeft - walkX;
    this.el.nativeElement.scrollTop = this.scrollTop - walkY;
  }

  @HostListener('document:mouseup')
  @HostListener('document:mouseleave')
  onMouseUp() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.renderer.setStyle(this.el.nativeElement, 'cursor', 'grab');
    this.renderer.removeStyle(this.el.nativeElement, 'user-select');
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    if (!this.isDragging) {
      this.renderer.setStyle(this.el.nativeElement, 'cursor', 'grab');
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (!this.isDragging) {
      this.renderer.removeStyle(this.el.nativeElement, 'cursor');
    }
  }
}
